var merchantLoaded = false;
function loadMerchantWidget() {
  if (merchantLoaded) return;
  merchantLoaded = true;
  var script = document.createElement('script');
  script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
  script.async = true;
  script.onload = function () {
    merchantwidget.start({
      position: 'RIGHT_BOTTOM',
      region: 'CA'
    });
  };
  document.head.appendChild(script);
}
['scroll', 'click', 'keydown', 'touchstart'].forEach(function(event) {
  window.addEventListener(event, loadMerchantWidget, { once: true, passive: true });
});
